import { render, staticRenderFns } from "./CommunityInfo.vue?vue&type=template&id=7399baad"
import script from "./CommunityInfo.vue?vue&type=script&lang=js"
export * from "./CommunityInfo.vue?vue&type=script&lang=js"
import style0 from "./CommunityInfo.vue?vue&type=style&index=0&id=7399baad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports